import { YODL_ENS_DOMAIN } from '@frontend/common';
import { Button, TextField } from '@radix-ui/themes';

interface JustanameAddressInputProps {
  isLoading?: boolean;
  onUsernameChange?: (username: string) => void;
  placeholder?: string;
  value?: string;
}

const JustanameAddressInput = ({
  isLoading = false,
  onUsernameChange,
  placeholder = 'Enter username',
  value = '',
}: JustanameAddressInputProps) => {
  return (
    <TextField.Root
      radius="full"
      disabled={isLoading}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onUsernameChange?.(e.target.value)}
      size="3"
    >
      <TextField.Slot />
      <TextField.Slot>
        <Button radius="full" variant="soft" color="purple" size="1">
          .{YODL_ENS_DOMAIN}
        </Button>
      </TextField.Slot>
    </TextField.Root>
  );
};

export default JustanameAddressInput;
